import { Component } from '@angular/core';

@Component({
	selector: 'nm-footer',
	templateUrl: './footer.html',
	host: {
		'class': 'footer',
		'style': 'display: block;'
	}
})
export class NmFooter {

}


// WEBPACK FOOTER //
// ./src/widgets/footer/footer.ts